import compact from "lodash/compact";
import type { ReactNode } from "react";
import React from "react";
import { Container } from "react-bootstrap";

interface Props {
	id?: string;
	className?: string;
	title: ReactNode;
	subTitle?: ReactNode;
	variant?: "purple" | "orange" | "green" | "blue";
	fakeHeader?: boolean;
	badge?: ReactNode;
	showSubTitleOnMobileDevice?: boolean;
}

export class LandingCover extends React.PureComponent<Props> {
	public render(): ReactNode {
		const {
			id,
			className,
			title,
			subTitle,
			children,
			fakeHeader,
			variant = "purple",
			showSubTitleOnMobileDevice = false,
			badge,
		} = this.props;

		return (
			<div id={id} className={compact(["position-relative py-lg-4 py-3", className]).join(" ")}>
				<div className={`d-cover bg-trianglify-${variant} bg-border-bottom position-absolute`} />
				<Container className="text-white mb-3">
					<div className="d-flex align-items-center">
						{!fakeHeader ? (
							<h1 className="display-1 display-bold mb-0">{title}</h1>
						) : (
							<span className="h1 display-1 display-bold mb-0">{title}</span>
						)}
						{badge && <div className="d-none d-md-block">{badge}</div>}
					</div>

					<div className={`display-4${showSubTitleOnMobileDevice ? " mt-2 mt-md-0" : " d-md-block d-none"}`}>
						{subTitle}
					</div>
					{badge && <div className="d-md-none">{badge}</div>}
				</Container>
				{children}
			</div>
		);
	}
}
